module.exports = __webpack_public_path__ + "img/012-girl-5.e95ff83d.svg";